export default function Remove() {
  return (
    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="RemoveIcon">
      <path d="M19 13H5v-2h14v2z" />
    </svg>
  );
}
